import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PageHeader, PageHeaderProps } from 'antd';

export const PageHeaderStyled: FunctionComponent<PageHeaderProps> = styled(PageHeader)`
  padding: 0;
  .ant-page-header-heading-title {
    display: flex;
    align-items: center;
    div {
      margin-left: 1rem;
      font-weight: 100;
      span {
        font-weight: 600;
      }
    }
  }
  .ant-page-header-heading-extra {
    div {
      font-size: 1.25rem;
      span {
        margin-left: 0.313rem;
        font-weight: 600;
      }
    }
  }
`;

export const HeaderLeftStyled = styled.div`
  display: flex;
`;
